import { useQuery } from '@tanstack/react-query';
import {
    fetchCommunicationsInsights,
    type CommunicationsInsightsGranularity
} from '../services/communicationsInsights';
import { COMMUNICATIONS_INSIGHTS_KEY } from './queryKeys';

// Backs all three Accounts Overview analytics cards from one shared query
// keyed by granularity, so they never drift out of sync.
export function useCommunicationsInsights(granularity: CommunicationsInsightsGranularity) {
    const query = useQuery({
        queryKey: COMMUNICATIONS_INSIGHTS_KEY(granularity),
        queryFn: () => fetchCommunicationsInsights(granularity),
        staleTime: 60_000
    });

    return {
        insights: query.data ?? null,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}
